import comp from "./AssignmentSettings";
export default comp;
